<script setup lang="ts">
import Field from './Field.vue';
import { computed } from 'vue';
import type { FieldLayout } from './props';
import Skeleton from 'primevue/skeleton';

const props = defineProps<{
    layout?: FieldLayout;
    label?: string;
}>();

const layout = computed(() => props.layout ?? 'horizontal');
</script>

<template>
    <Field :layout="layout">
        <template #label>
            <Skeleton :width="label" />
        </template>
        <Skeleton height="2rem" width="100%" />
    </Field>
</template>
